<template>
  <div>
    <div v-if="data[activeResourceType] && data[activeResourceType].length > 0">
      <!-- PAGINATION TOP -->
      <fob-entity-list-pagination
        @update:current="onPageChange"
        :disable-switch="true"
        :per-page="config[activeResourceType].perPage"
        :page="config[activeResourceType].page"
        :total="total[activeResourceType]"
      >
      </fob-entity-list-pagination>
      <!-- LIST OF COMPACTED ENTITIES -->
      <div class="fob-entity-compact-view">
        <fob-entity-list-compact-cyan
          :data="data[activeResourceType]"
          :show-publications-count="activeResourceType === 'forschungsprojekt'"
          :show-publication-type="activeResourceType === 'publikation'"
          :loading="isLoading"
          entityDetailsRoute="public_details"
          entityEditRoute="editieren"
        ></fob-entity-list-compact-cyan>
      </div>
      <!-- PAGINATION BOTTOM -->
      <fob-entity-list-pagination
        @update:current="onPageChange"
        :disable-switch="true"
        :per-page="config[activeResourceType].perPage"
        :page="config[activeResourceType].page"
        :total="total[activeResourceType]"
      >
      </fob-entity-list-pagination>
    </div>
    <!-- No data hint -->
    <div v-else style="padding: 1rem;" class="fob-public-view-no-data">
      <div class="columns">
        <div class="column" style="max-width: 50px;">
          <b-icon icon="exclamation" type="is-garnet"></b-icon>
        </div>
        <div class="column">
          <em><translate>list.noData</translate></em>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import EntityListCompactCyan from '@/components/EntityListCompactCyan'
import EntityListPagination from '@/components/EntityListPagination'
import PublicViewHelper from '@/components/mixins/PublicViewHelper'

export default {
  name: 'fob-public-list-compact',
  mixins: [PublicViewHelper],
  computed: {
    ...mapGetters({
      userIsLoggedIn: 'user/isAuthorized',
      data: 'publicView/getData',
      config: 'publicView/getConfig',
      schema: 'publicView/getSchema',
      total: 'publicView/getTotal',
      isLoading: 'publicView/isLoading'
    }),
    userIsAdmin () {
      return this.userIsLoggedIn && this.$store.getters['user/roles'].ADMIN === true
    }
  },
  methods: {
    onPageChange (page) {
      this.$store.dispatch('publicView/changePage', {
        resourceType: this.activeResourceType,
        page
      })
      this.loadAsyncData()
    }
  },
  components: {
    'fob-entity-list-compact-cyan': EntityListCompactCyan,
    'fob-entity-list-pagination': EntityListPagination
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/public/PublicListCompact.vue